import { getAuthAxiosBackend } from "../helpers/axios"

class AlbumServices{

    getAll(){
        return getAuthAxiosBackend().get('albums')
    }
}

export default new AlbumServices()